module.exports = __webpack_public_path__ + "img/P150T_weapon_115.facbe202.png";